import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerWrapper,
} from 'approot/activity-builder/activity-builder-drawer';
import type { GetStimulusResourceQuery } from '../../../shared/stimulus/stimulus.graphql.generated';
import StimulusUsageMessage from '../shared/stimulus-message';
import {
  SettingsTitleView,
  SettingsRichtextView,
  SettingsThumbnailView,
  SettingsCoverImageView,
} from '../shared/settings-view';
import { getClosestImageUrl } from 'approot/shared/images/imgix-responsive';
import type { Pluck } from 'lib/gql/pluck';

type Props = {
  componentId: string;
  contentId: number;
  sectionId: string;
  stimulus: Extract<
    Pluck<GetStimulusResourceQuery, 'getStimulusResource'>,
    { __typename: 'StimulusResourceDocument' }
  >;
  title?: string;
};

const DocumentEditStimulusPreview = ({
  stimulus,
  title,
  componentId,
  contentId,
  sectionId,
}: Props) => {
  const { closeDrawer } = useActivityBuilderContext();
  return (
    <ActivityBuilderDrawerWrapper>
      <ActivityBuilderDrawerHeader
        title={title || stimulus.type}
        onClose={closeDrawer}
      />
      <ActivityBuilderDrawerContent>
        <StimulusUsageMessage
          componentId={componentId}
          stimulusId={stimulus.id}
          contentId={contentId}
          sectionId={sectionId}
        />
        <SettingsTitleView title="Stimulus Name" value={stimulus.name} />
        <SettingsRichtextView
          title="Stimulus Description"
          value={stimulus.description}
        />
        <SettingsThumbnailView
          title="Stimulus Thumbnail"
          imageUrl={stimulus.coverImage?.responsive?.[0].urls.at(-1)?.url}
        />
        {stimulus.xlCoverImageUrls?.length ? (
          <SettingsCoverImageView
            title="Stimulus Cover in Activity Builder"
            imageUrl={getClosestImageUrl({
              imageUrls: stimulus.xlCoverImageUrls,
              containerSize: 300,
            })}
          />
        ) : null}
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

export default DocumentEditStimulusPreview;
